import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import outputs from '../../amplify_outputs.json';
import { Schema } from '../../amplify/data/resource';

// Amplify Gen2の初期化
Amplify.configure(outputs);

// クライアントの生成
export const client = generateClient<Schema>({
    authMode: 'identityPool',
});
